import MaskedInput from "react-text-mask";
import { CommaSeprator, convertIntoLakh } from "../../UtilityComponents/UtilityFunction";
import { useState } from "react";
import { useEffect } from "react";
import BarGraphCostOfDelay from "../BarGraphCostOfDelay";
function GoalCalc(props) {
    const [GoalAmount, setGoalAmount] = useState(5000000);
    const [InvestmentPeriod, setInvestmentPeriod] = useState(10);
    const [MaturityYear, setMaturityYear] = useState(15);
    const [InterestRate, setInterestRate] = useState(8);
    const [monthlySIP, setMonthlySIP] = useState(null);
    const [YearlySIP, setYearlySIP] = useState(null);
    const [err, setErr] = useState({})

    const calculateSIP = (PV) => {
        const P = parseFloat(PV);
        const n = parseFloat(InvestmentPeriod) * 12;
        const r = parseFloat(InterestRate) / 100 / 12;

        // Calculate the monthly SIP required using the formula
        const monthlyInvestment = (P * r).toFixed(2) / (Math.pow(1 + r, n) - 1).toFixed(2);
        setMonthlySIP(monthlyInvestment.toFixed(2));
        setYearlySIP((monthlyInvestment * 12).toFixed(2))
        //console.log(monthlyInvestment)
    };

    useEffect(() => {
        setMaturityYear(props.maturity);
        setInvestmentPeriod(props.investmentPeriod);
    }, [props]);

    useEffect(() => {
        let goto = true;
        let error = {};
        if (GoalAmount < 25000) {
            goto = false;
            error["goal"] = "Minimum goal amount should be atleast 25 thousand";
            //console.log(goto);
        }
        if (+MaturityYear < + InvestmentPeriod) {
            goto = false;
            error["maturity"] = "Maturity year should be equal or greater than investment year"
        }
        if (InvestmentPeriod < 1) {
            goto = false;
            error["investYrs"] = "Investment year should be min 1 year";
        }
        setErr(error);

        if (goto) {
            setErr('');
            const fv = GoalAmount;
            const n = MaturityYear - InvestmentPeriod;
            let r = InterestRate / 100;
            // let PV= fv/Math.pow(1+r, n);
            let PV = fv / (1 + r) ** n;
            //console.log(PV);
            PV = PV.toFixed(2);
            //console.log("pv", PV)
            calculateSIP(+PV)
        }
    }, [GoalAmount, MaturityYear, InvestmentPeriod, InterestRate])

    return (
        <div className="Calculator InvestmentLoginPage">
            <div className="CalculatorHead">
                <h2>Calculate by Goal Amount</h2>
                <button className="clsBtn" onClick={props.onc}>
                    <img src={require("../../Cross.svg").default} alt="" />
                </button>
            </div>
            <div id="invstmntcalc" className="row">
                <div className="col-md-6">
                    <form>
                        <div className="CalcForm">
                            <label className="InLabel" htmlFor="investmentAmount">Your Goal Amount</label>
                            <MaskedInput
                                mask={[
                                    /[0-9]/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                ]}
                                guide={false}
                                showMask={false}
                                className="packageForm"
                                value={CommaSeprator("₹" + GoalAmount)}
                                onChange={(e) => setGoalAmount(e.target.value) }
                            />
                            <span className="InvAmntSet">₹{convertIntoLakh(GoalAmount)}</span>
                            <small class="Error-Text">{err.goal}</small>
                        </div>

                        <div className="CalcForm">
                            <label className="InLabel" htmlFor="investmentPeriod">
                                Investment Period
                            </label>

                            <MaskedInput
                                mask={[
                                    /[0-9]/,
                                    /\d/,


                                ]}
                                guide={false}
                                showMask={false}
                                className="packageForm"
                                value={InvestmentPeriod}
                                onChange={(e) => { setInvestmentPeriod(e.target.value) }
                                }
                            />
                            <span className="yearsSet">{InvestmentPeriod ? "years" : ""}</span>
                            <small class="Error-Text">{err.investYrs}</small>
                        </div>

                        <div className="CalcForm">
                            <label className="InLabel" htmlFor="maturity">Maturity After</label>
                            <MaskedInput
                                mask={[
                                    /[0-9]/,
                                    /\d/,


                                ]}
                                guide={false}
                                showMask={false}
                                className="packageForm"
                                value={MaturityYear}
                                onChange={(e) => setMaturityYear(e.target.value)}
                            />
                            <span className="yearsSet">{MaturityYear ? "years" : ""}</span>
                            <small class="Error-Text">{err.maturity}</small>
                        </div>

                        <div className="CalcForm">
                            <label className="InLabel" htmlFor="interestRate">Expected Interest Rate</label>
                            <MaskedInput
                                mask={[
                                    /[0-9]/,
                                    /\d/,
                                ]}
                                guide={false}
                                showMask={false}
                                className="packageForm"
                                value={InterestRate}
                            />
                            <span className="RateSet">{InterestRate ? "%" : ""}</span>

                            <input
                                type="range"
                                className="slider border-0"
                                min={1}
                                max={30}
                                step={1}
                                value={InterestRate}
                                onChange={(e) => setInterestRate(e.target.value)}
                            />
                            <ul className="InterestRate SIPdelaymonth">
                                <li>1%</li>
                                <li>5%</li>
                                <li>10%</li>
                                <li>15%</li>
                                <li>20%</li>
                                <li>25%</li>
                                <li>30%</li>
                            </ul>
                        </div>



                    </form>
                </div>
                <div className="col-md-6">


                    <div className="CalcAmtInvt costofdelay">
                        <div className='CODbox'>
                            <p>Invest <strong>₹{CommaSeprator(monthlySIP)}/month</strong> (₹{CommaSeprator(YearlySIP)}/Year) for {InvestmentPeriod} years to reach the goal of <strong>₹{convertIntoLakh(GoalAmount)}</strong></p>
                        </div>
                    </div>

                    {YearlySIP && <div className="BarGraph GoalAmount">
                        <BarGraphCostOfDelay
                            year={InvestmentPeriod}
                            percent={Math.round((GoalAmount / GoalAmount) * 100)}
                            amt={GoalAmount}
                            Msg="Your goal amount"
                            IsDelayGraph={false}
                        />
                        {GoalAmount >= 25000 ? < BarGraphCostOfDelay
                            year={InvestmentPeriod}
                            percent={Math.round(((YearlySIP * InvestmentPeriod) / GoalAmount) * 100)}
                            amt={YearlySIP * InvestmentPeriod}
                            Msg="Your invested amount"
                            IsDelayGraph={true}
                        /> : <div className="BlankDiv" style={{height:"100px"} }>

                        </div>}
                        <small class="Error-Text">{err.goal}</small>
                    </div>}

                </div>
            </div>


            <small className="Disclaimer">
                <i>
                    * Valid for guaranteed return plans
                </i>
            </small>

        </div>

    )
}

export default GoalCalc;